/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Generates a FileType enum and associated ContentType enum with their implementations.

This macro takes a list of tuples in the format:
(Variant, "extension", "mime_type", CONTENT_TYPE_VARIANT)

For each tuple it generates:
- A variant in the FileType enum
- A variant in the ContentType enum
- Implementations for:
  - FileType::to_str() - Converts FileType to extension string
  - FileType::from_str() - Converts extension string to FileType
  - From<FileType> for ContentType - Maps FileType to ContentType
  - ContentType::mime_type() - Gets MIME type for ContentType

 */
export type FileType = (typeof FileType)[keyof typeof FileType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileType = {
  docx: 'docx',
  pdf: 'pdf',
  md: 'md',
  canvas: 'canvas',
  coffee: 'coffee',
  cson: 'cson',
  iced: 'iced',
  c: 'c',
  i: 'i',
  cpp: 'cpp',
  cppm: 'cppm',
  cc: 'cc',
  ccm: 'ccm',
  cxx: 'cxx',
  cxxm: 'cxxm',
  cplusplus: 'cplusplus',
  cplusplusm: 'cplusplusm',
  hpp: 'hpp',
  hh: 'hh',
  hxx: 'hxx',
  hplusplus: 'hplusplus',
  h: 'h',
  ii: 'ii',
  ino: 'ino',
  inl: 'inl',
  ipp: 'ipp',
  ixx: 'ixx',
  tpp: 'tpp',
  txx: 'txx',
  hppin: 'hppin',
  hin: 'hin',
  cu: 'cu',
  cuh: 'cuh',
  cs: 'cs',
  csx: 'csx',
  cake: 'cake',
  css: 'css',
  dart: 'dart',
  diff: 'diff',
  patch: 'patch',
  rej: 'rej',
  dockerfile: 'dockerfile',
  containerfile: 'containerfile',
  go: 'go',
  handlebars: 'handlebars',
  hbs: 'hbs',
  hjs: 'hjs',
  hlsl: 'hlsl',
  hlsli: 'hlsli',
  fx: 'fx',
  fxh: 'fxh',
  vsh: 'vsh',
  psh: 'psh',
  cginc: 'cginc',
  compute: 'compute',
  html: 'html',
  htm: 'htm',
  shtml: 'shtml',
  xhtml: 'xhtml',
  xht: 'xht',
  mdoc: 'mdoc',
  jsp: 'jsp',
  asp: 'asp',
  aspx: 'aspx',
  jshtm: 'jshtm',
  volt: 'volt',
  ejs: 'ejs',
  rhtml: 'rhtml',
  ini: 'ini',
  conf: 'conf',
  properties: 'properties',
  cfg: 'cfg',
  directory: 'directory',
  gitattributes: 'gitattributes',
  gitconfig: 'gitconfig',
  gitmodules: 'gitmodules',
  editorconfig: 'editorconfig',
  repo: 'repo',
  java: 'java',
  jav: 'jav',
  jsx: 'jsx',
  js: 'js',
  es6: 'es6',
  mjs: 'mjs',
  cjs: 'cjs',
  pac: 'pac',
  json: 'json',
  bowerrc: 'bowerrc',
  jscsrc: 'jscsrc',
  webmanifest: 'webmanifest',
  jsmap: 'jsmap',
  cssmap: 'cssmap',
  tsmap: 'tsmap',
  har: 'har',
  jslintrc: 'jslintrc',
  jsonld: 'jsonld',
  geojson: 'geojson',
  ipynb: 'ipynb',
  vuerc: 'vuerc',
  jsonc: 'jsonc',
  eslintrc: 'eslintrc',
  eslintrcjson: 'eslintrcjson',
  jsfmtrc: 'jsfmtrc',
  jshintrc: 'jshintrc',
  swcrc: 'swcrc',
  hintrc: 'hintrc',
  babelrc: 'babelrc',
  jsonl: 'jsonl',
  ndjson: 'ndjson',
  codesnippets: 'codesnippets',
  jl: 'jl',
  jmd: 'jmd',
  sty: 'sty',
  cls: 'cls',
  bbx: 'bbx',
  cbx: 'cbx',
  tex: 'tex',
  ltx: 'ltx',
  ctx: 'ctx',
  bib: 'bib',
  less: 'less',
  log: 'log',
  lua: 'lua',
  mak: 'mak',
  mk: 'mk',
  mkd: 'mkd',
  mdwn: 'mdwn',
  mdown: 'mdown',
  markdown: 'markdown',
  markdn: 'markdn',
  mdtxt: 'mdtxt',
  mdtext: 'mdtext',
  workbook: 'workbook',
  m: 'm',
  mm: 'mm',
  pl: 'pl',
  pm: 'pm',
  pod: 'pod',
  t: 't',
  psgi: 'psgi',
  raku: 'raku',
  rakumod: 'rakumod',
  rakutest: 'rakutest',
  rakudoc: 'rakudoc',
  nqp: 'nqp',
  p6: 'p6',
  pl6: 'pl6',
  pm6: 'pm6',
  php: 'php',
  php4: 'php4',
  php5: 'php5',
  phtml: 'phtml',
  ctp: 'ctp',
  ps1: 'ps1',
  psm1: 'psm1',
  psd1: 'psd1',
  pssc: 'pssc',
  psrc: 'psrc',
  py: 'py',
  rpy: 'rpy',
  pyw: 'pyw',
  cpy: 'cpy',
  gyp: 'gyp',
  gypi: 'gypi',
  pyi: 'pyi',
  ipy: 'ipy',
  pyt: 'pyt',
  r: 'r',
  rhistory: 'rhistory',
  rprofile: 'rprofile',
  rt: 'rt',
  cshtml: 'cshtml',
  razor: 'razor',
  rb: 'rb',
  rbx: 'rbx',
  rjs: 'rjs',
  gemspec: 'gemspec',
  rake: 'rake',
  ru: 'ru',
  erb: 'erb',
  podspec: 'podspec',
  rbi: 'rbi',
  rs: 'rs',
  scss: 'scss',
  sass: 'sass',
  shader: 'shader',
  sh: 'sh',
  bash: 'bash',
  bashrc: 'bashrc',
  bashaliases: 'bashaliases',
  bashprofile: 'bashprofile',
  bashlogin: 'bashlogin',
  ebuild: 'ebuild',
  eclass: 'eclass',
  profile: 'profile',
  bashlogout: 'bashlogout',
  xprofile: 'xprofile',
  xsession: 'xsession',
  xsessionrc: 'xsessionrc',
  zsh: 'zsh',
  zshrc: 'zshrc',
  zprofile: 'zprofile',
  zlogin: 'zlogin',
  zlogout: 'zlogout',
  zshenv: 'zshenv',
  zshtheme: 'zshtheme',
  fish: 'fish',
  ksh: 'ksh',
  csh: 'csh',
  cshrc: 'cshrc',
  tcshrc: 'tcshrc',
  yashrc: 'yashrc',
  yashprofile: 'yashprofile',
  sql: 'sql',
  dsql: 'dsql',
  swift: 'swift',
  ts: 'ts',
  cts: 'cts',
  mts: 'mts',
  tsx: 'tsx',
  tsbuildinfo: 'tsbuildinfo',
  xml: 'xml',
  xsd: 'xsd',
  ascx: 'ascx',
  atom: 'atom',
  axml: 'axml',
  axaml: 'axaml',
  bpmn: 'bpmn',
  cpt: 'cpt',
  csl: 'csl',
  csproj: 'csproj',
  csprojuser: 'csprojuser',
  dita: 'dita',
  ditamap: 'ditamap',
  dtd: 'dtd',
  ent: 'ent',
  mod: 'mod',
  dtml: 'dtml',
  fsproj: 'fsproj',
  fxml: 'fxml',
  iml: 'iml',
  isml: 'isml',
  jmx: 'jmx',
  launch: 'launch',
  menu: 'menu',
  mxml: 'mxml',
  nuspec: 'nuspec',
  opml: 'opml',
  owl: 'owl',
  proj: 'proj',
  props: 'props',
  pt: 'pt',
  publishsettings: 'publishsettings',
  pubxml: 'pubxml',
  pubxmluser: 'pubxmluser',
  rbxlx: 'rbxlx',
  rbxmx: 'rbxmx',
  rdf: 'rdf',
  rng: 'rng',
  rss: 'rss',
  shproj: 'shproj',
  storyboard: 'storyboard',
  targets: 'targets',
  tld: 'tld',
  tmx: 'tmx',
  vbproj: 'vbproj',
  vbprojuser: 'vbprojuser',
  vcxproj: 'vcxproj',
  vcxprojfilters: 'vcxprojfilters',
  wsdl: 'wsdl',
  wxi: 'wxi',
  wxl: 'wxl',
  wxs: 'wxs',
  xaml: 'xaml',
  xbl: 'xbl',
  xib: 'xib',
  xlf: 'xlf',
  xliff: 'xliff',
  xpdl: 'xpdl',
  xul: 'xul',
  xoml: 'xoml',
  xsl: 'xsl',
  xslt: 'xslt',
  yaml: 'yaml',
  yml: 'yml',
  eyaml: 'eyaml',
  eyml: 'eyml',
  cff: 'cff',
  yamltmlanguage: 'yamltmlanguage',
  yamltmpreferences: 'yamltmpreferences',
  yamltmtheme: 'yamltmtheme',
  winget: 'winget',
  txt: 'txt',
  csv: 'csv',
  tsv: 'tsv',
  jpeg: 'jpeg',
  jpg: 'jpg',
  png: 'png',
  gif: 'gif',
  svg: 'svg',
  webp: 'webp',
  avif: 'avif',
  bmp: 'bmp',
  ico: 'ico',
  tiff: 'tiff',
  tif: 'tif',
  heic: 'heic',
  heif: 'heif',
  tar: 'tar',
  targz: 'targz',
  tgz: 'tgz',
  gz: 'gz',
  bz2: 'bz2',
  tarbz2: 'tarbz2',
  tbz2: 'tbz2',
  z: 'z',
  tarz: 'tarz',
  lz: 'lz',
  tarlz: 'tarlz',
  xz: 'xz',
  tarxz: 'tarxz',
  txz: 'txz',
  lzma: 'lzma',
  tarlzma: 'tarlzma',
  rar: 'rar',
  sevenz: 'sevenz',
  zst: 'zst',
  tarzst: 'tarzst',
  tzst: 'tzst',
  zip: 'zip',
  exe: 'exe',
  msi: 'msi',
  dll: 'dll',
  bat: 'bat',
  cmd: 'cmd',
  com: 'com',
  appimage: 'appimage',
  app: 'app',
  bin: 'bin',
  deb: 'deb',
  rpm: 'rpm',
  apk: 'apk',
  dmg: 'dmg',
  pkg: 'pkg',
  crx: 'crx',
  xpi: 'xpi',
  mp3: 'mp3',
  wav: 'wav',
  ogg: 'ogg',
  flac: 'flac',
  aac: 'aac',
  m4a: 'm4a',
  wma: 'wma',
  mid: 'mid',
  midi: 'midi',
  mp4: 'mp4',
  mkv: 'mkv',
  webm: 'webm',
  avi: 'avi',
  mov: 'mov',
  wmv: 'wmv',
  mpg: 'mpg',
  mpeg: 'mpeg',
  m4v: 'm4v',
  flv: 'flv',
  f4v: 'f4v',
  threegp: 'threegp',
  ttf: 'ttf',
  otf: 'otf',
  woff: 'woff',
  woff2: 'woff2',
  eot: 'eot',
  rtf: 'rtf',
  odt: 'odt',
  ods: 'ods',
  odp: 'odp',
  odg: 'odg',
  odf: 'odf',
  epub: 'epub',
  mobi: 'mobi',
  azw: 'azw',
  azw3: 'azw3',
  djvu: 'djvu',
  xls: 'xls',
  ppt: 'ppt',
  pptx: 'pptx',
  xlsx: 'xlsx',
  db: 'db',
  sqlite: 'sqlite',
  sqlite3: 'sqlite3',
  mdb: 'mdb',
  accdb: 'accdb',
  dbf: 'dbf',
  plist: 'plist',
  toml: 'toml',
  env: 'env',
  dot: 'dot',
  gv: 'gv',
  torrent: 'torrent',
  ics: 'ics',
  vcf: 'vcf',
  ai: 'ai',
  eps: 'eps',
  ps: 'ps',
  dxf: 'dxf',
  dwg: 'dwg',
  stl: 'stl',
  obj: 'obj',
  fbx: 'fbx',
  blend: 'blend',
  dae: 'dae',
  threeds: 'threeds',
  gltf: 'gltf',
  glb: 'glb',
  vhd: 'vhd',
  vhdx: 'vhdx',
  vmdk: 'vmdk',
  ova: 'ova',
  ovf: 'ovf',
  iso: 'iso',
  img: 'img',
  swf: 'swf',
} as const;
